import { SearchBar } from "../../components/search-bar";
import { ApplicationDictionariesProvider } from "../application-detail-page/application-dictionaries-context";
import { PageStoreProvider } from "./applications-page.lib";
import { ApplicationsImportButton } from "./local-components/applications-import-button";
import { ApplicationsImportModal } from "./local-components/applications-import-modal";
import { ApplicationsPageTitle } from "./local-components/applications-page-title";
import { ApplicationsStatsSection } from "./local-components/applications-stats-section";
import { ApplicationsTable } from "./local-components/applications-table";
import { AttentionSection } from "./local-components/attention-section";
import { CreateApplicationButton } from "./local-components/create-application-button";
import { ApplicationsExportButton } from "./local-components/applications-export-button";
import { FoundItemsCount } from "./local-components/found-items-count";
import { UpdateListButton } from "./local-components/update-list-button";

const ApplicationsPage = () => (
  <ApplicationDictionariesProvider>
    <PageStoreProvider>
      <ApplicationsImportModal />
      <main className="bg-neutrals-white flex min-h-0 w-full flex-1 flex-col overflow-hidden rounded-t-[10px]">
        <div className="flex min-h-0 flex-1 flex-col gap-6 overflow-hidden px-8 pb-6 pt-6">
          <div className="flex shrink-0 flex-col gap-6 overflow-y-auto">
            <section className="flex flex-col gap-6">
              <div className="flex flex-col gap-3">
                <ApplicationsPageTitle />
                <p className="subtitle-sm text-type-minor">Обзор всех заявок на получение технических условий</p>
              </div>
              <ApplicationsStatsSection />
            </section>
            <div className="flex items-center justify-between gap-4">
              <div className="flex min-w-0 items-center gap-2">
                <SearchBar placeholder="Поиск по заявкам" className="ml-0.5 w-80 shrink-0" size="sm" clearable />
                <div className="bg-neutrals-90 h-8 w-px shrink-0" />
                <UpdateListButton />
                <FoundItemsCount />
              </div>
              <div className="ml-auto flex gap-4 px-1">
                <CreateApplicationButton />
                <ApplicationsImportButton />
                <ApplicationsExportButton />
              </div>
            </div>
            <AttentionSection />
          </div>
          <section className="flex min-h-0 flex-1 flex-col">
            <ApplicationsTable className="min-h-0 flex-1" />
          </section>
        </div>
      </main>
    </PageStoreProvider>
  </ApplicationDictionariesProvider>
);

export default ApplicationsPage;
